import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Keycloak from 'keycloak-js';
import axios from 'axios'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import VeeValidate, {Validator} from "vee-validate";
import italian from 'vee-validate/dist/locale/it'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'leaflet/dist/leaflet.css';
import moment from "moment"
import { Icon } from "leaflet";
import './assets/fix-sticky-headers.css'

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});


Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Validator.localize('it', italian)
moment.locale('it')

Vue.use(VeeValidate, {
  locale: 'it',
  inject: true,
  fieldsBagName: "veeFields",
  errorBagName: "veeErrors",
  useConstraintAttrs: false
});

Vue.config.productionTip = false;

let session = new Keycloak({
  url: `${process.env.VUE_APP_KEYCLOAK_URL}/auth`,
  realm: 'dao-fidelity-card',
  clientId: 'backoffice'
});

session.init({ onLoad: 'login-required' })
  .then(auth => {

    if (!auth) {
      window.location.reload();
    }

    axios.interceptors.request.use(config => {
      config.headers.Authorization = `Bearer ${session.token}`;
      return config
    }, error => {
      console.error(error);
      return Promise.reject(error)
    });

    setInterval(() => session.updateToken(60).catch(err => console.error(`Failed to refresh token: ${err}`)), 30000);

    new Vue({
      router,
      render: h => h(App, {props: {session}})
    }).$mount('#app');

  })
  .catch(err => console.error(`Authentication Failed ${err}`));
